var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49625 0.75C2.42625 0.75 0.75 2.43 0.75 4.5C0.75 6.57 2.42625 8.25 4.49625 8.25C6.57 8.25 8.25 6.57 8.25 4.5C8.25 2.43 6.57 0.75 4.49625 0.75ZM4.5 7.5C2.8425 7.5 1.5 6.1575 1.5 4.5C1.5 2.8425 2.8425 1.5 4.5 1.5C6.1575 1.5 7.5 2.8425 7.5 4.5C7.5 6.1575 6.1575 7.5 4.5 7.5ZM4.4175 2.625H4.395C4.245 2.625 4.125 2.745 4.125 2.895V4.665C4.125 4.79625 4.1925 4.92 4.30875 4.9875L5.865 5.92125C5.9925 5.99625 6.1575 5.95875 6.2325 5.83125C6.31125 5.70375 6.27 5.535 6.13875 5.46L4.6875 4.5975V2.895C4.6875 2.745 4.5675 2.625 4.4175 2.625Z",
    fill: "#223E7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a8a52a6f0974adfd3345e9c4532bea3c.svg";
export { ForwardRef as ReactComponent };